module.exports = __webpack_public_path__ + "static/media/diamalfi-removebg-preview.8133157d.png";